/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'ka',
  Pagination: {
    // Options.jsx
    items_per_page: '/ გვ.',
    jump_to: 'გადასვლა',
    jump_to_confirm: 'დადასტურება',
    page: '',

    // Pagination.jsx
    prev_page: 'წინა გვერდი',
    next_page: 'შემდეგი გვერდი',
    prev_5: 'წინა 5 გვერდი',
    next_5: 'შემდეგი 5 გვერდი',
    prev_3: 'წინა 3 გვერდი',
    next_3: 'შემდეგი 3 გვერდი'
  },
  DatePicker: {
    lang: {
      today: 'დღეს',
      now: 'ახლა',
      backToToday: 'მიმდინარე თარიღი',
      ok: 'დიახ',
      clear: 'გასუფთავება',
      month: 'თვე',
      year: 'წელი',
      timeSelect: 'აირჩიეთ დრო',
      dateSelect: 'აირჩიეთ თარიღი',
      weekSelect: 'აირჩიეთ კვირა',
      monthSelect: 'აირჩიეთ თვე',
      yearSelect: 'აირჩიეთ წელი',
      decadeSelect: 'აირჩიე ათწლეული',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'წინა თვე (PageUp)',
      nextMonth: 'შემდეგი თვე (PageDown)',
      previousYear: 'წინა წელი (Control + left)',
      nextYear: 'შემდეგი წელი (Control + right)',
      previousDecade: 'წინა ათწლეული',
      nextDecade: 'შემდეგი ათწლეული',
      previousCentury: 'წინა საუკუნე',
      nextCentury: 'შემდეგი საუკუნე'
    },
    timePickerLocale: {
      placeholder: 'აირჩიეთ დრო'
    }
  },
  TimePicker: {
    placeholder: 'აირჩიეთ დრო'
  },
  Calendar: {
    lang: {
      today: 'დღეს',
      now: 'ახლა',
      backToToday: 'მიმდინარე თარიღი',
      ok: 'დიახ',
      clear: 'გასუფთავება',
      month: 'თვე',
      year: 'წელი',
      timeSelect: 'აირჩიეთ დრო',
      dateSelect: 'აირჩიეთ თარიღი',
      weekSelect: 'აირჩიეთ კვირა',
      monthSelect: 'აირჩიეთ თვე',
      yearSelect: 'აირჩიეთ წელი',
      decadeSelect: 'აირჩიე ათწლეული',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'წინა თვე (PageUp)',
      nextMonth: 'შემდეგი თვე (PageDown)',
      previousYear: 'წინა წელი (Control + left)',
      nextYear: 'შემდეგი წელი (Control + right)',
      previousDecade: 'წინა ათწლეული',
      nextDecade: 'შემდეგი ათწლეული',
      previousCentury: 'წინა საუკუნე',
      nextCentury: 'შემდეგი საუკუნე'
    },
    timePickerLocale: {
      placeholder: 'აირჩიეთ დრო'
    }
  },
  global: {
    placeholder: 'აირჩიეთ'
  },
  Table: {
    filterTitle: 'ფილტრი',
    filterConfirm: 'დიახ',
    filterReset: 'განულება',
    selectAll: 'აირჩიეთ მიმდინარე გვერდი',
    selectInvert: 'გვერდის მიმართულების შეცვლა',
    sortTitle: 'სორტირება'
  },
  Modal: {
    okText: 'დიახ',
    cancelText: 'გაუქმება',
    justOkText: 'დიახ'
  },
  Popconfirm: {
    okText: 'დიახ',
    cancelText: 'გაუქმება'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'ძიება',
    itemUnit: 'ელემ.',
    itemsUnit: 'ელემ.'
  },
  Upload: {
    uploading: 'იტვირტება...',
    removeFile: 'ფაილის წაშლა',
    uploadError: 'ატვირთვის შეცდომა',
    previewFile: 'ფაილის გადახედვა'
  },
  Empty: {
    description: 'მონაცემი არ არის'
  },
  Icon: {
    icon: 'ხატულა'
  },
  Text: {
    edit: 'რედაქტირება',
    copy: 'კოპირება',
    copied: 'წარმატებით დაკოპირდა',
    expand: 'გახსნა'
  },
  PageHeader: {
    back: 'უკან'
  }
};
